/**
 * Label Customization component
 *
 * @module component-label-customization
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = "component-label-customization";

if (!customElements.get(customElements.component)) {
  class LabelCustomizationComponent extends HTMLElement {
    constructor() {
      super();

      window.addEventListener("message", (event) => {
        if (event.data.action === "labelCreated") {
          this.handleLabelCreated(event.data);
          // close the dialog
          this.querySelector("dialog").close();
        }

        if (event.data.action === "closeLabelCustomization") {
          this.querySelector("dialog").close();
          window.document.location.reload();
        }
      });
    }

    render() {}
  }

  customElements.define(customElements.component, LabelCustomizationComponent);
}
